var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 8.25v4.5m3-4.5v4.5M3 5.25h12m-.75 0l-.65 9.107a1.5 1.5 0 01-1.496 1.393H5.897A1.5 1.5 0 014.4 14.357L3.75 5.25h10.5zm-3 0V3a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v2.25h4.5z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Trash.defaultProps = {"viewBox":"0 0 18 18","style":{"display":"block"}};

module.exports = Trash;

Trash.default = Trash;
